export default __webpack_public_path__ + "static/media/tenLogo.2809e9f0.png";